export default {
  title: 'Mẫu SMS',

  // Form related
  form: {
    tempName: 'Tên Mẫu',
    tempNamePlaceholder: 'Vui lòng nhập tên mẫu',
    country: 'Quốc Gia',
    countryPlaceholder: 'Vui lòng chọn quốc gia',
    category: 'Danh Mục',
    categoryPlaceholder: 'Vui lòng chọn danh mục',
    channel: 'Kênh',
    channelPlaceholder: 'Vui lòng chọn kênh',
    provider: 'Nhà Cung Cấp',
    providerPlaceholder: 'Vui lòng chọn nhà cung cấp',
    status: 'Trạng Thái',
    statusPlaceholder: 'Vui lòng chọn trạng thái',
    content: 'Nội Dung Mẫu',
    contentPlaceholder: 'Vui lòng nhập nội dung mẫu, hỗ trợ biến: {username}/{vip_level}/{kyc_name}/{nickname}/{promo_pool_id}/{user_points}/{phone_number}',
    shortChain: 'Liên Kết Ngắn',
    shortChainPlaceholder: 'Vui lòng nhập liên kết ngắn (tùy chọn)',
    agentCode: 'Mã Đại Lý',
    agentCodePlaceholder: 'Vui lòng nhập mã đại lý (tùy chọn)',
    loginChannel: 'Kênh Đăng Nhập',
    loginChannelPlaceholder: 'Vui lòng chọn'
  },

  // Country related
  country: {
    PH: 'Philippines',
    VN: 'Việt Nam',
    CN: 'Trung Quốc',
    US: 'Hoa Kỳ'
  },

  // Table related
  table: {
    tempName: 'Tên Mẫu',
    country: 'Quốc Gia',
    category: 'Danh Mục',
    channel: 'Kênh',
    provider: 'Nhà Cung Cấp',
    content: 'Nội Dung Mẫu',
    loginChannel: 'Kênh Đăng Nhập',
    status: 'Trạng Thái',
    actions: 'Thao Tác'
  },

  // Status related
  status: {
    enabled: 'Kích Hoạt',
    disabled: 'Vô Hiệu Hóa'
  },

  // Button related
  button: {
    create: 'Tạo Mẫu',
    manageCategory: 'Quản Lý Danh Mục',
    test: 'Gửi Thử'
  },

  // Modal related
  modal: {
    createTitle: 'Tạo Mẫu SMS',
    editTitle: 'Chỉnh Sửa Mẫu SMS'
  },

  // Template variables related
  variables: {
    title: 'Biến Mẫu Được Hỗ Trợ',
    tip: 'Nhấp vào biến để chèn vào nội dung mẫu',
    username: 'Tên người dùng (trống nếu không có)',
    vipLevel: 'Cấp VIP (ví dụ: VIP3)',
    kycName: 'Tên KYC (có sẵn sau xác minh)',
    nickname: 'Biệt danh (trống nếu không có)',
    promoPool: 'Pool khuyến mãi (ví dụ: {promo_pool_7788833399})',
    userPoints: 'Số Dư Điểm Người Dùng (Điểm Người Dùng)',
    phoneNumber: 'Số điện thoại người dùng (ẩn một phần)'
  },

  // Validation related
  validation: {
    tempNameRequired: 'Vui lòng nhập tên mẫu',
    countryRequired: 'Vui lòng chọn quốc gia',
    categoryRequired: 'Vui lòng chọn danh mục',
    channelRequired: 'Vui lòng chọn kênh',
    providerRequired: 'Vui lòng chọn nhà cung cấp',
    contentRequired: 'Vui lòng nhập nội dung mẫu',
    statusRequired: 'Vui lòng chọn trạng thái'
  },

  // Message related
  message: {
    queryFailed: 'Truy vấn thất bại',
    createSuccess: 'Tạo thành công',
    createFailed: 'Tạo thất bại',
    updateSuccess: 'Cập nhật thành công',
    updateFailed: 'Cập nhật thất bại',
    deleteSuccess: 'Xóa thành công',
    deleteFailed: 'Xóa thất bại',
    statusUpdateSuccess: 'Cập nhật trạng thái thành công',
    statusUpdateFailed: 'Cập nhật trạng thái thất bại'
  },

  // Confirm related
  confirm: {
    delete: 'Bạn có chắc chắn muốn xóa mẫu này không?',
    toggleStatus: 'Bạn có chắc chắn muốn chuyển đổi trạng thái của mẫu này không?'
  },

  // Pagination related
  pagination: {
    total: 'Tổng cộng {{total}} bản ghi'
  },

  // Test send related
  test: {
    title: 'Gửi Thử SMS',
    templateName: 'Tên Mẫu',
    templateContent: 'Nội Dung Mẫu',
    inputLabel: 'Người Nhận',
    inputPlaceholder: 'Vui lòng nhập số điện thoại hoặc tài khoản thành viên',
    inputHint: 'Hệ thống sẽ tự động nhận diện bạn nhập số điện thoại hay tài khoản thành viên',
    send: 'Gửi',
    inputRequired: 'Vui lòng nhập số điện thoại hoặc tài khoản thành viên',
    success: 'Gửi thử thành công',
    failed: 'Gửi thử thất bại',
    error: 'Lỗi gửi thử',
    userNotFound: 'Người dùng thử nghiệm không có trong hệ thống của chúng tôi'
  },

  // Category management related
  category: {
    modal: {
      title: 'Quản Lý Danh Mục Mẫu'
    },
    table: {
      id: 'ID',
      name: 'Tên Danh Mục',
      actions: 'Thao Tác'
    },
    form: {
      namePlaceholder: 'Vui lòng nhập tên danh mục'
    },
    button: {
      create: 'Tạo Danh Mục'
    },
    confirm: {
      delete: 'Bạn có chắc chắn muốn xóa danh mục này không?',
      deleteDesc: 'Hành động này không thể hoàn tác, vui lòng thận trọng'
    },
    defaultActivity: 'Hoạt Động',
    defaultReminder: 'Nhắc Nhở',
    allCategories: 'Tất Cả Danh Mục',
    nameRequired: 'Vui lòng nhập tên danh mục',
    nameExists: 'Tên danh mục đã tồn tại',
    queryFailed: 'Truy vấn danh mục thất bại',
    createSuccess: 'Tạo danh mục thành công',
    createFailed: 'Tạo danh mục thất bại',
    deleteSuccess: 'Xóa danh mục thành công',
    deleteFailed: 'Xóa danh mục thất bại'
  }
};
